import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import Light from './icons/Light';
import TV from './icons/TV';
import WashingMachine from './icons/WashingMachine';
import Microwave from './icons/Microwave';
import Refrigerator from './icons/Refrigerator';
import AC from './icons/AC';
import ElectricOven from './icons/ElectricOven';
import Dishwasher from './icons/Dishwasher';
import Cooker from './icons/Cooker';
import Car from './icons/Car';
import CoffeeMaker from './icons/CoffeeMaker';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
// import EfSpec from '@elem/ui/ef-spec';

let sceneTextEnterNA2: any = null,
    sceneTextLeaveNA2: any = null;
export default function NA2() {
    const { useLang, useRouter, useEffect, useState, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);
    const [gap, setGap] = useState(24);

    const basicArr = [
        {
            icon: <Light />,
            text: t('secNA2_icon1'),
        },
        {
            icon: <TV />,
            text: t('secNA2_icon2'),
        },
        {
            icon: <WashingMachine />,
            text: t('secNA2_icon3'),
        },
        {
            icon: <Microwave />,
            text: t('secNA2_icon4'),
        },
        {
            icon: <Refrigerator />,
            text: t('secNA2_icon5'),
        },
        {
            icon: <AC />,
            text: t('secNA2_icon6'),
        },
    ];

    const advancedArr = [
        {
            icon: <ElectricOven />,
            text: t('secNA2_icon7'),
        },
        {
            icon: <Dishwasher />,
            text: t('secNA2_icon8'),
        },
        {
            icon: <Cooker />,
            text: t('secNA2_icon9'),
        },
    ];

    const hassleFreeArr = [
        {
            icon: <Car />,
            text: t('secNA2_icon10'),
        },
        {
            icon: <CoffeeMaker />,
            text: t('secNA2_icon11'),
        },
    ];

    const cards: any[] = [
        {
            img: '/responsive/picture/delta-pro-ultra/launch/25_1.jpg',
            backup: t('secNA2_card1_backup'),
            title: t('secNA2_card1_title'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/launch/25_2.jpg',
            backup: t('secNA2_card2_backup'),
            title: t('secNA2_card2_title'),
        },
        {
            img: '/responsive/picture/delta-pro-ultra/launch/25_3.jpg',
            backup: t('secNA2_card3_backup'),
            title: t('secNA2_card3_title'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resize = () => setGap(window?.innerWidth > 1440 ? 24 : window?.innerWidth > 1024 ? 20 : 16);
            resize();
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterNA2) {
                    AniContainer.removeScene(sceneTextEnterNA2);
                    sceneTextEnterNA2 = null;
                }
                if (sceneTextLeaveNA2) {
                    AniContainer.removeScene(sceneTextLeaveNA2);
                    sceneTextLeaveNA2 = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterNA2 = AniContainer.create({
                    triggerElement: '.dpu-detail-NA2',
                    triggerHook: 1,
                    offset: startH, //textTarget?.offsetHeight,
                    duration: 200, //textTarget?.offsetHeight / 2,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            return () => {
                if (sceneTextEnterNA2) {
                    AniContainer.removeScene(sceneTextEnterNA2);
                    sceneTextEnterNA2 = null;
                }
                if (sceneTextLeaveNA2) {
                    AniContainer.removeScene(sceneTextLeaveNA2);
                    sceneTextLeaveNA2 = null;
                }
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-NA2 dpu-detail-section ${css['dpu-detail-NA2']}`}>
            {locale === 'us' && <EfSpec />}

            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <h2 className="title">{t('secNA2_title')}</h2>
                {/* <p className="desc">{t('secNA2_desc')}</p> */}
            </div>
            <Swiper className="cards swiper-box" modules={[Pagination]} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0} pagination={true}>
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="img-box">
                            <EFPicture src={`${card?.img}`} alt={card?.title} />
                        </div>
                        <div className="card-content">
                            <p className={`card-backup`}>{card?.backup}</p>
                            <p className={`card-title`}>{card?.title}</p>
                            <ul className="basic lists">
                                {basicArr?.map((basic: any, m: number) => (
                                    <li className="list" key={`basic_${k}_${m}`}>
                                        <div className="icon">{basic?.icon}</div>
                                        <p className="text">{basic.text}</p>
                                    </li>
                                ))}
                            </ul>
                            {k !== 0 && (
                                <ul className="advanced lists">
                                    {advancedArr?.map((advanced: any, n: number) => (
                                        <li className="list" key={`advanced_${k}_${n}`}>
                                            <div className="icon">{advanced?.icon}</div>
                                            <p className="text">{advanced.text}</p>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {k === 2 && (
                                <ul className="hassle lists">
                                    {hassleFreeArr?.map((hassle: any, l: number) => (
                                        <li className="list" key={`hassle_${k}_${l}`}>
                                            <div className="icon">{hassle?.icon}</div>
                                            <p className="text">{hassle.text}</p>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {locale === 'us' && (
                <Link
                    className="dpu-calculator"
                    href="/calculators/delta-pro-ultra"
                    target="_blank"
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'calculator_entry',
                        button_name: 'Help me choose with the calculator >',
                    }}
                >
                    {'Help me choose with the calculator >'}
                </Link>
            )}
            <EfSpec />
        </section>
    );
}
